import { Pipe, PipeTransform } from '@angular/core';
import { CartItem } from 'app/features/cart';
import { TranslationService } from 'app/translation';
import { Observable } from 'rxjs';

/**
 * CartCurrentListGroupHeaderPipe
 *
 * This pipe is used to find the correct translation string for the cart list group header
 */
@Pipe({
  name: 'cartCurrentListGroupHeader',
})
export class CartCurrentListGroupHeaderPipe implements PipeTransform {
  /**
   * @param translationService Translate Service implementation
   */
  constructor(private translationService: TranslationService) {}

  /**
   * Transforms a cartItemGroup to a translated string for this cart item group as header text
   *
   * @param cartItemGroup Cart item group array
   * @returns Translated text for cart item group header
   */
  transform(cartItemGroup: Array<CartItem>): Observable<any> {
    if (cartItemGroup[0].SerialNumber) {
      let serialNumber: string = cartItemGroup[0].SerialNumber;
      const pumpType: string = cartItemGroup[0].PumpType;
      if (pumpType) {
        serialNumber = serialNumber.concat(' (', pumpType, ')');
      }
      return this.translationService.translate('CART.MACHINE_SPAREPARTS', { serialNumber });
    }

    return this.translationService.translate('CART.NO_MACHINE_SPAREPARTS');
  }
}
